<template>
  <v-navigation-drawer class='red--text_ text--light-5' id='app-drawer' v-model='inputValue' persistent app dark
    mobile-breakpoint="991" width="250">
    <v-layout class="fill-height_" tag="v-list" column>
      <v-list>
        <v-list-item style="margin:0px;margin:15px;padding:0px">
          <img style="width:100%" src='/img/logo_emn_trial_office.svg' />
        </v-list-item>

        <div style="text-align:right;padding-right:10px;margin-left:5px;">
          <h4 style="font-size:0.8em !important;letter-spacing: 7px;color: orange;font-weight: 400 !important;">SERVICES
          </h4>
        </div>

        <v-divider />
        <component v-for="(link, i) in allowedLinks" :is="link.type" :key="i" v-bind="link" avatar />
      </v-list>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'
import links from './menu'

export default {
  data: () => ({
    logo: '/img/logo.png',
    responsive: true,
    links
  }),
  computed: {
    ...mapState('app', ['image', 'color', 'schema']),

    // display allowed links only
    allowedLinks() {
      return links.filter(link => !link.entity || this.$can(link.action, link.entity))
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.setDrawer(val)
      }
    },
    items() {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant() {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  async mounted() {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
#app-drawer {
  background-color: rgba(47, 47, 47, 0.84);

  .v-list-item {
    border-radius: 4px !important;

    &::before {
      border-radius: 4px !important;
    }
  }
}
</style>
